'use strict';

var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var Card = require('../../../DesignSystem/Surfaces/Cards/Card.js');
var CardContent = require('../../../DesignSystem/Surfaces/Cards/CardContent.js');
var withStyles = require('../../../DesignSystem/Styles/withStyles.js');
var Grid = require('../../../DesignSystem/Layout/Grid/Grid.js');
var Typography = require('../../../DesignSystem/DataDisplay/Typography/Typography.js');
var TruncateText = require('../../../utils/TruncateText.js');
require('prop-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles(theme) {
  return {
    appCardWidth: {
      width: 90,
      height: 90,
      '&:hover': {
        background: theme.palette.hover.main,
        cursor: 'pointer'
      }
    },
    cardContent: {
      padding: '10px 3px'
    },
    iconContainer: {
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  };
};

var AppTile = function AppTile(_ref) {
  var classes = _ref.classes,
      icon = _ref.icon,
      appName = _ref.appName;
      _ref.openAppURL;
      var restOfProps = objectWithoutProperties(_ref, ["classes", "icon", "appName", "openAppURL"]);

  return React__default["default"].createElement(Card, _extends["default"]({}, restOfProps, {
    elevation: 0,
    className: classes.appCardWidth
  }), React__default["default"].createElement("div", {
    className: classes.appCardContainer
  }, React__default["default"].createElement(CardContent, {
    className: classes.cardContent
  }, React__default["default"].createElement(Grid, {
    container: true,
    spacing: 0,
    alignItems: 'center',
    className: classes.iconContainer
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, icon), React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(Typography, {
    variant: "body2"
  }, React__default["default"].createElement(TruncateText, {
    maxLines: 1
  }, appName)))))));
};

var AppTile$1 = withStyles["default"](styles)(AppTile);

module.exports = AppTile$1;
